export const TABS = [
  { key: "all", value: "", translationKey: "base.all" },
  {
    key: "onGoing",
    value: "PUBLISHED,IN_PROGRESS",
    translationKey: "base.onGoing",
  },
  { key: "completed", value: "COMPLETED", translationKey: "base.completed" },
];
